<template>
  <div class="home">
    <!-- 根据路由 meta 信息判断是否显示导航栏 -->
    <NavBar v-if="$route.meta.requireAuth" />
    <router-view />
  </div>
</template>

<script>
import NavBar from "../components/MyNavBar.vue";

export default {
  name: "Home",
  components: {
    NavBar,
  },
};
</script>

<style scoped>
.home {
  min-height: 100vh;
  background-color: #f5f7fb;
}
</style>